import { Transforms as SlateTransforms } from 'slate';

import AIAssistantTransforms from './ai-assistant-transforms';
import BookmarkTransforms from './bookmark-transforms';
import CannedFieldTransforms from './canned-field-transforms';
import { CertificateTransforms } from './certificate-transforms';
import ColorTransforms from './color-transforms';
import CommentTransforms from './comment-transforms';
import { DocumentTransforms } from './document-transforms';
import DrawingTransforms from './drawing-transforms';
import DynamicContentTransforms from './dynamic-content';
import FieldTransforms from './field-transforms';
import FooterTransforms from './footer-transforms';
import FormatTransforms from './format-transforms';
import GeneralTransforms from './general-transforms';
import HeaderTransforms from './header-transforms';
import LinkTransforms from './link-transforms';
import { ListTransforms } from './list-transforms';
import PageNumberingTransforms from './page-numbering-transforms';
import ParagraphTransforms from './paragraph-transforms';
import { RedlineTransforms } from './redline-transforms';
import SelectionTransforms from './selection-transforms';
import SuggestionMarkerTransforms from './suggestion-marker-transforms';
import { SuggestionWithSourceTransforms } from './suggestion-with-source-transforms';
import TabTransforms from './tab-transforms';
import TableTransforms from './table-transforms';
import TextTransforms from './text-transforms';
import TocTransforms from './toc-transforms';
import TrackedChangesTransforms from './tracked-changes-transforms';

export const AlineTransforms = {
  ...SlateTransforms,
  ...AIAssistantTransforms,
  ...BookmarkTransforms,
  ...CannedFieldTransforms,
  ...RedlineTransforms,
  ...CertificateTransforms,
  ...ColorTransforms,
  ...CommentTransforms,
  ...DocumentTransforms,
  ...DrawingTransforms,
  ...DynamicContentTransforms,
  ...FieldTransforms,
  ...FooterTransforms,
  ...FormatTransforms,
  ...GeneralTransforms,
  ...HeaderTransforms,
  ...LinkTransforms,
  ...ListTransforms,
  ...ParagraphTransforms,
  ...SelectionTransforms,
  ...SuggestionMarkerTransforms,
  ...SuggestionWithSourceTransforms,
  ...TabTransforms,
  ...TableTransforms,
  ...TextTransforms,
  ...TrackedChangesTransforms,
  ...PageNumberingTransforms,
  ...TocTransforms,
};
